import { planTypes } from '@/common/constants';

export default {
  data() {
    return {
      logo: require('@/assets/plans/zcm.svg'),
      title: this.$t('billing.zcm.title'),
      planType: planTypes.ZCM,
      configDescription: this.$t('billing.zcm.description'),
    };
  },
};
